// Generated by genversion.
module.exports = '5.6.0'
